import React from 'react';
import { useWishlist } from './WishlistContext';
import Button from '../common/Button';

const AddToWishlistButton = props => {
  const { loaded, isWishlisted, addCard } = useWishlist();
  // Membership comes from the wishlist context, so an already-wishlisted card
  // reads correctly on first render instead of only after you click it.
  const wishlisted = loaded && isWishlisted(props.card.id);

  return (
    <Button
      className="w-full "
      iconClass={`fas ${wishlisted ? 'fa-check' : 'fa-heart'}`}
      onClick={() => addCard(props.card.id)}
      disabled={wishlisted}>
      {wishlisted ? 'Agregado a wishlist' : 'Agregar a wishlist'}
    </Button>
  );
};

export default AddToWishlistButton;
